import { useStore } from 'effector-react'
import { DiscountChip } from '~/entities/BookingCar'
import { viewerModel } from '~/entities/viewer'
import { BookingCarDiscount } from '~/shared/api'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import {
  LastInspectionButtonAuth,
  LastInspectionButtonUnAuth,
} from './LastInspection'
import { Wrapper, Chip, Img, IsLeasingFullyPaidChip } from './styled'

type PhotosProps = {
  plateNumber: string
  photos: string[]
  isLeasingFullyPaid: boolean
  taxiparkId?: UniqueId
  inspectionId?: UniqueId
  discount?: BookingCarDiscount
  pricePerDay: number
}

export function MainBlock({
  plateNumber,
  photos,
  isLeasingFullyPaid,
  inspectionId,
  taxiparkId,
  discount,
  pricePerDay,
}: PhotosProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const authenticated = viewerModel.useAuthenticated()

  const photo = photos?.[0]
  return (
    <Wrapper>
      <Img src={photo} alt='booking-car-photo' />
      <Chip>{plateNumber}</Chip>

      {isLeasingFullyPaid && (
        <IsLeasingFullyPaidChip>Возможен выкуп</IsLeasingFullyPaidChip>
      )}
      {discount && (
        <DiscountChip
          discount={discount}
          pricePerDay={pricePerDay}
          style={{
            top: isLeasingFullyPaid ? '46px' : '12px',
            right: '12px',
            bottom: 'auto',
          }}
        />
      )}

      {featureFlags.last_inspection && (
        <>
          {authenticated ? (
            inspectionId ? (
              <LastInspectionButtonAuth inspectionId={inspectionId} />
            ) : null
          ) : (
            <LastInspectionButtonUnAuth taxiparkId={taxiparkId} />
          )}
        </>
      )}
    </Wrapper>
  )
}
